import LogoSvg from "../assets/img/svg/logo.svg";
import Bell from "../assets/img/svg/bell.svg";
import ArrowDownSvg from "../assets/img/svg/arrow_down_white.svg";
import DateSvg from "../assets/img/svg/ic-date.svg";
import ListSvg from "../assets/img/svg/ic-list.svg";
import PenSvg from "../assets/img/svg/ic-pen.svg";
import PenWhiteSvg from "../assets/img/svg/ic-pen-white.svg";
import CardSvg from "../assets/img/svg/ic-card.svg";
import LockSvg from "../assets/img/svg/ic-lock.svg";
import UploadSvg from "../assets/img/svg/ic-upload.svg";
import DocCalanderSvg from "../assets/img/svg/doc-calander.svg";
import DocCalanderWhiteSvg from "../assets/img/svg/doc-calander-white.svg";
import UploadPolicies from "../components/Popups/UploadPolicies.vue";
import {
  IVF_TREATMENT_LIST_ENABLED,
  EXCEPTION_COMMITTEE_ENABLED
} from "../utilities/feature-flags.js";
import { mapActions, mapGetters } from "vuex";

export const menuIcons = {
  date: DateSvg,
  list: ListSvg,
  pen: PenSvg,
  penWhite: PenWhiteSvg,
  card: CardSvg,
  lock: LockSvg,
  upload: UploadSvg,
  contact: DocCalanderSvg,
  contactWhite: DocCalanderWhiteSvg
};

export const menuComponents = {
  LogoSvg,
  Bell,
  ArrowDownSvg,
  DateSvg,
  ListSvg,
  PenSvg,
  PenWhiteSvg,
  CardSvg,
  LockSvg,
  UploadSvg,
  DocCalanderSvg,
  DocCalanderWhiteSvg
};

export default {
  computed: {
    ...mapGetters([
      "activeUser",
      "activeDoctor",
      "doctors",
      "hasUnwatchedDocs",
      "docsTypes",
      "showIVF"
    ])
  },
  methods: {
    ...mapActions(["LOGOUT"]),
    logout() {
      sessionStorage.removeItem("initial-route");
      this.LOGOUT().then(() => {
        this.$API.logout().then(() => this.$router.push("/"));
      });
    },
    onRoute(path, closeMenu) {
      if (closeMenu && typeof this.CLOSE_MENU === "function") {
        this.CLOSE_MENU();
      }
      if (this.$route.path == path || this.$route.path == path + "/") {
        if (path.includes("cellosign") || path.includes("cellosign-iframe")) {
          this.$router.go(0);
        }
        return;
      }
      this.$router.push(path);
    },
    dropMenu(el) {
      if ($(el.target).hasClass("active")) {
        $(el.target)
          .closest(".menu_item")
          .find(".drop_open")
          .slideUp();
        $(el.target)
          .closest(".menu_item")
          .find(".menu_item_top")
          .removeClass("active");
      } else {
        $(el.target)
          .closest(".menu_item")
          .find(".drop_open")
          .slideDown();
        $(el.target)
          .closest(".menu_item")
          .find(".menu_item_top")
          .addClass("active");
      }
      $(el.target).toggleClass("active");
    },
    openUploadPolicies(closeMenu) {
      if (closeMenu && typeof this.CLOSE_MENU === "function") {
        this.CLOSE_MENU();
      }
      this.$modal.show(UploadPolicies);
    },
    runMenuAction(action, closeMenu) {
      const handlers = { uploadPolicies: this.openUploadPolicies };
      if (handlers[action]) {
        handlers[action](closeMenu);
      }
    },
    matchesDocsType(path) {
      return Object.keys(this.docsTypes).some(key => path.includes(key));
    },
    isMenuItemVisible(item) {
      if (item.path === "/table/ivf" && !IVF_TREATMENT_LIST_ENABLED) {
        return false;
      }
      if (
        item.path === "/cellosign-iframe/exception-committee" &&
        !EXCEPTION_COMMITTEE_ENABLED
      ) {
        return false;
      }
      if (item.requiresIVF && !this.showIVF) {
        return false;
      }
      return true;
    },
    visibleMenuChildren(children = []) {
      return children.filter(child => this.isMenuItemVisible(child));
    }
  }
};
